import * as React from 'react';
type SvgTikTokProps = React.SVGProps<SVGSVGElement>;

const SvgTikTok = (props: SvgTikTokProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="37"
    fill="none"
    viewBox="0 0 38 37"
  >
    <g fill="#fff" clipPath="url(#clip0_1041_11940)">
      <rect width="37" height="37" x="0.5" fillOpacity="0.1" rx="4.933"></rect>
      <path
        fillRule="evenodd"
        d="M19.035 4.934a.53.53 0 0 0-.53.53v18.031a2.653 2.653 0 0 1-5.303 0 2.653 2.653 0 0 1 2.651-2.651.53.53 0 0 0 .53-.53V16.07a.53.53 0 0 0-.53-.53 7.96 7.96 0 0 0-7.955 7.954 7.96 7.96 0 0 0 7.955 7.955 7.96 7.96 0 0 0 7.955-7.955v-8.753a9 9 0 0 0 3.713.798h1.06a.53.53 0 0 0 .53-.53v-4.243a.53.53 0 0 0-.53-.53h-1.06a3.714 3.714 0 0 1-3.713-3.712V5.464a.53.53 0 0 0-.53-.53zm.53 1.06h3.183v.53a4.775 4.775 0 0 0 4.773 4.774h.53v3.182h-.53a7.9 7.9 0 0 1-3.977-1.066.53.53 0 0 0-.796.46v9.621a6.9 6.9 0 0 1-6.895 6.895 6.9 6.9 0 0 1-6.894-6.895 6.9 6.9 0 0 1 6.364-6.874v3.2a3.715 3.715 0 0 0-3.182 3.674 3.714 3.714 0 0 0 3.712 3.713 3.714 3.714 0 0 0 3.713-3.713z"
        clipRule="evenodd"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_1041_11940">
        <rect width="37" height="37" x="0.5" fill="#fff" rx="4.933"></rect>
      </clipPath>
    </defs>
  </svg>
);

export default SvgTikTok;
